module.exports = __webpack_public_path__ + "static/media/domain1.b11f995e.png";